// extracted by mini-css-extract-plugin
export default {"container":"PrimaryDropdown-module--container--PmoZ+","menu":"PrimaryDropdown-module--menu--um2iO","menuWrapper":"PrimaryDropdown-module--menuWrapper--n-usw"};